import { render, staticRenderFns } from "./IconElementImage.vue?vue&type=template&id=281c7885&"
import script from "./IconElementImage.vue?vue&type=script&lang=js&"
export * from "./IconElementImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281c7885')) {
      api.createRecord('281c7885', component.options)
    } else {
      api.reload('281c7885', component.options)
    }
    module.hot.accept("./IconElementImage.vue?vue&type=template&id=281c7885&", function () {
      api.rerender('281c7885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementImage.vue"
export default component.exports